import { FeatureFlagsFacade } from '@mode/shared/contract-common';
import { first } from 'rxjs';

export function getFlags(document: Document): unknown | undefined {
  const flagsContent = document.head.querySelector('#featureFlagState')?.textContent;
  return flagsContent ? JSON.parse(flagsContent) : undefined;
}
